import { ReactNode } from "react";

import { AppLayout } from "shared/Layout";
import { fetchSettings } from "shared/SettingsProvider/settings.helper";
import { withApp } from "utils/with-app.utils";
import { fetchTranslations } from "utils/with-i18n.utils";
import { fetchSEO, withSeo } from "utils/with-seo.utils";

import { Banner } from "./Banner";
import { Co2 } from "./Co2";
import { Hero } from "./Hero";
import { Leasing } from "./Leasing";
import { Numbers } from "./Numbers";
import { Reconditioned } from "./Reconditioned";

export type EnvironmentProps = Awaited<
  ReturnType<typeof getStaticProps>
>["props"];

export const Environment = () => {
  return (
    <>
      <Hero />
      <Numbers />
      <Leasing />
      <Banner />
      <Reconditioned />
      <Co2 />
    </>
  );
};

Environment.getLayout = (page: ReactNode, pageProps: EnvironmentProps) => (
  <AppLayout withBanner {...pageProps}>
    {page}
  </AppLayout>
);

export const getStaticProps = async () => {
  const translations = await fetchTranslations(["marquee", "environment"]);

  const seo = await fetchSEO("environnement");

  return {
    props: {
      translations,
      seo,
      settings: await fetchSettings(),
    },
  };
};

export default withApp(Environment, [withSeo]);
